import * as moment from 'moment';
import * as _ from 'lodash';

import { guidEmpty, jobStarted } from '../../../common';
import { Configurations, Steps } from '../../../common/Steps';
import { ComponentDefinition, IDateRange, ITaskConfiguration, OfflineTaskType } from '../../../models';
import { ExcludedDates, ILoggerService, ITaskService } from '../../../services';
import { Step } from '../../groupComputation/Step';

interface ITaskConfigurationWithRange extends ITaskConfiguration {
    beginDateTime: string;
    endDateTime: string;
}

class TaskLaunchModalController implements angular.IComponentController {
    beginDateTime: string;
    endDateTime: string;
    excludedDates: (ExcludedDates | IDateRange)[];
    id: string;
    initialRange: IDateRange;
    steps: Step[];
    task: ITaskConfiguration;

    // used in template to ease readbility
    readonly ACQUISITION: OfflineTaskType = OfflineTaskType.Acquisition;
    readonly REPROCESSING: OfflineTaskType = OfflineTaskType.Reprocessing;
    readonly CLEANING: OfflineTaskType = OfflineTaskType.Cleaning;

    private readonly _possibleSteps: { label: string; propertyName: string }[];

    static $inject = [
        '$rootScope',
        'translatedLoggerService',
        'taskService'
    ];

    constructor(
        private _$rootScope: angular.IScope,
        private _loggerService: ILoggerService,
        private _taskService: ITaskService,
    ) {
        this._possibleSteps = Steps.concat(Configurations);
    }

    $onInit() {
        // nothing
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['task']?.currentValue) {
            this.task.guid = guidEmpty;
            this.updateViewModels();
            $(`#${this.id}`).modal('show');
        }
    }

    testTask() {
        this._taskService
            .checkTask(this.task)
            .then(data => {
                const hasDates = (this.task.type === OfflineTaskType.Reprocessing)
                    ? _.some(data as ExcludedDates[], d => d.value?.length > 0)
                    : data.length > 0;

                if (hasDates)
                {
                    this.excludedDates = data;
                    $(`#${this.id}_confirm`).modal('show');
                }
                else
                {
                    this.createTask();
                }
            })
            .catch(reason => {
                this._loggerService.logError('Failed to check task dates for approval.');
            });
    }

    createTask(): angular.IPromise<void> {

        if (this.hasDates(this.task)) {
            // reassign dates from picker
            const t = this.task as ITaskConfigurationWithRange;
            t.beginDateTime = this.beginDateTime;
            t.endDateTime = this.endDateTime;
        }

        if (this.task.type === OfflineTaskType.Reprocessing) {
            // reassign step in task configuration
            this._possibleSteps.forEach((s, i) => {
                this.task[s.propertyName] = this.steps[i].value;
            });
        }

        return this._taskService
            .createTask(this.task)
            .then(() => {
                this._loggerService.logSuccess('Task started.');
                this._$rootScope.$broadcast(jobStarted);
            })
            .catch(reason => {
                this._loggerService.logError(reason);
            });
    }

    // return if task has a begin/end date
    private hasDates(task: ITaskConfiguration): boolean {
        return (task.type !== OfflineTaskType.Cleaning);
    }

    private updateViewModels(): void {
        this.updateRange();
        this.updateSteps();
    }

    private updateRange(): void {
        if (this.hasDates(this.task)) {
            const t = this.task as ITaskConfigurationWithRange;
            this.initialRange = {
                beginDate: moment(t.beginDateTime),
                endDate: moment(t.endDateTime)
            };
        }
    }

    private updateSteps() {
        this.steps = this._possibleSteps
            .map(s => {
                return {
                    label: s.label,
                    value: !!this.task[s.propertyName]
                };
            });
    }
}

export const wtTaskLaunchModal: ComponentDefinition = {
    componentId: 'wtTaskLaunchModal',
    controller: TaskLaunchModalController,
    controllerAs: 'vm',
    template: require('./taskLaunchModal.component.html'),
    bindings: {
        id: '@',
        task: '<'
    }
};